import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import type { BaseContainerSection } from '@adornis/buildify/db/extensions/BaseSection.js';
import '@adornis/chemistry/elements/components/x-flex';
import { BuildifyCampusSectionExtension } from '@adornis/digitale-helden-shared/client/theme/buildify/extensions/BuildifyCampusSectionExtension.js';
import '@adornis/file-utils/client/x-image';
import '../../client/theme/d-text.js';

export const MarketingSectionExtension: BuildifyExtension<BaseContainerSection> = {
  ...BuildifyCampusSectionExtension,
  defaultValues: {
    ...BuildifyCampusSectionExtension.defaultValues,
    padding: { global: '0 16px' },
  },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <d-section-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></d-section-extension>
    `;
  },
};

import type { Styles } from '@adornis/ass/style.js';
import { XSectionExtension } from '@adornis/buildify/client/extensions/ContainerSectionExtension.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('d-section-extension')
export class DSectionExtension extends XSectionExtension {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          padding: this.getValue('padding'),
        },
        'd-section': {
          padding: '0',
        },
      },
    ] as Styles[];
  }
}
